import DisctrictSchools from './DisctrictSchools.page';

export default DisctrictSchools;